(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('tslib'), require('@ts-ioc/core'), require('core-js')) :
	typeof define === 'function' && define.amd ? define(['tslib', '@ts-ioc/core', 'core-js'], factory) :
	(global['platform-browser'] = global['platform-browser'] || {}, global['platform-browser'].umd = global['platform-browser'].umd || {}, global['platform-browser'].umd.js = factory(global.tslib,global['@ts-ioc/core'],global['core-js']));
}(this, (function (tslib_1,core_1,coreJs) { 'use strict';

tslib_1 = tslib_1 && tslib_1.hasOwnProperty('default') ? tslib_1['default'] : tslib_1;
core_1 = core_1 && core_1.hasOwnProperty('default') ? core_1['default'] : core_1;
coreJs = coreJs && coreJs.hasOwnProperty('default') ? coreJs['default'] : coreJs;

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by rollup-plugin-commonjs');
}

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var BrowserModuleLoader_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });


var BrowserModuleLoader = /** @class */ (function (_super) {
    tslib_1.__extends(BrowserModuleLoader, _super);
    function BrowserModuleLoader() {
        return _super.call(this) || this;
    }
    BrowserModuleLoader.prototype.createLoader = function () {
        if (typeof System !== 'undefined') {
            return function (modulepath) {
                return System.import(modulepath);
            };
        }
        else {
            core_1.lang.assert(commonjsRequire, 'has not module loader');
            return function (modulepath) {
                return new Promise(function (resolve, reject) {
                    commonjsRequire([modulepath], function (mud) {
                        resolve(mud);
                    }, function (err) {
                        reject(err);
                    });
                });
            };
        }
    };
    BrowserModuleLoader.getClassAnnations = function () {
        return { "name": "BrowserModuleLoader", "params": { "constructor": [], "createLoader": [] } };
    };
    return BrowserModuleLoader;
}(core_1.DefaultModuleLoader));
exports.BrowserModuleLoader = BrowserModuleLoader;


});

unwrapExports(BrowserModuleLoader_1);
var BrowserModuleLoader_2 = BrowserModuleLoader_1.BrowserModuleLoader;

var BrowserModule_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });





/**
 * browser module for ioc. auto run setup after registered.
 * with @IocExt('setup') decorator.
 * @export
 * @class BrowserModule
 */
var BrowserModule = /** @class */ (function () {
    function BrowserModule(container) {
        this.container = container;
    }
    /**
     * register aop for container.
     *
     * @memberof AopModule
     */
    BrowserModule.prototype.setup = function () {
        var container = this.container;
        container.bindProvider(core_1.ModuleLoaderToken, new BrowserModuleLoader_1.BrowserModuleLoader());
        container.bindProvider(core_1.ContainerBuilderToken, new ContainerBuilder.BrowserContainerBuilder());
    };
    BrowserModule.getClassAnnations = function () {
        return { "name": "BrowserModule", "params": { "constructor": ["container"], "setup": [] } };
    };
    BrowserModule = tslib_1.__decorate([
        core_1.IocExt('setup'),
        tslib_1.__param(0, core_1.Inject(core_1.ContainerToken)),
        tslib_1.__metadata("design:paramtypes", [Object])
    ], BrowserModule);
    return BrowserModule;
}());
exports.BrowserModule = BrowserModule;


});

unwrapExports(BrowserModule_1);
var BrowserModule_2 = BrowserModule_1.BrowserModule;

var ContainerBuilder = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });




/**
 * container builder for browser.
 *
 * @export
 * @class ContainerBuilder
 * @extends {ContainerBuilder}
 */
var BrowserContainerBuilder = /** @class */ (function (_super) {
    tslib_1.__extends(BrowserContainerBuilder, _super);
    function BrowserContainerBuilder(loader) {
        return _super.call(this, loader || new BrowserModuleLoader_1.BrowserModuleLoader()) || this;
    }
    BrowserContainerBuilder.prototype.create = function () {
        var container = _super.prototype.create.call(this);
        container.use(BrowserModule_1.BrowserModule);
        return container;
    };
    BrowserContainerBuilder.getClassAnnations = function () {
        return { "name": "BrowserContainerBuilder", "params": { "constructor": ["loader"], "create": [] } };
    };
    return BrowserContainerBuilder;
}(core_1.ContainerBuilder));
exports.BrowserContainerBuilder = BrowserContainerBuilder;


});

unwrapExports(ContainerBuilder);
var ContainerBuilder_1 = ContainerBuilder.BrowserContainerBuilder;

var D__workspace_github_tsioc_packages_platformBrowser_lib = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

tslib_1.__exportStar(BrowserModuleLoader_1, exports);
tslib_1.__exportStar(ContainerBuilder, exports);
tslib_1.__exportStar(BrowserModule_1, exports);


});

var index = unwrapExports(D__workspace_github_tsioc_packages_platformBrowser_lib);

return index;

})));

//# sourceMappingURL=sourcemaps/platform-browser.umd.js.map
